<template>
  <div class="sidebar_widget">
    <div class="widget_heading">
      <h5 class="text-sidebar" >
        <i class="fa fa-headphones" aria-hidden="true"></i>
        Contáctanos
      </h5>
    </div>
    <div class="dealer_detail">
      <h6 class="text-center mt-4">
         <a href="https://wa.link/34pamh" class="text-muted text-center">
          <i class="fa fa-whatsapp"></i>
          318 8274142
        </a>
      </h6>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss"></style>
